import { Fragment } from 'react'
// MUI
import {
  Box,
  Divider,
  List,
  ListItemButton,
  styled,
  Typography,
} from '@mui/material'
import i18next from 'i18next'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
// Components
import { BottomDrawer } from '$common/bottom-drawer'
import { changeLanguage, t } from '$i18n'
import { ConfirmIcon } from '$common/icons/confirm-icon'

const languageInfo = [
  {
    name: 'settings.sections.language.persian',
    label: 'Persian',
    disabled: false,
    languageId: 'fa',
  },
  {
    name: 'settings.sections.language.arabic',
    label: 'Arabic',
    disabled: false,
    languageId: 'ar',
  },
  {
    name: 'settings.sections.language.english',
    label: 'English',
    disabled: true,
    languageId: 'en',
  },
]

const StyledListItemButton = styled(ListItemButton)({
  width: '100%',
  height: '50px',
  padding: '0 25px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

const IntendedDivider = styled(Divider)`
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  &.MuiDivider-inset {
    margin-right: 20px;
  }

  &:last-child {
    display: none;
  }
`

export function SelectLanguageModal({ isOpen }: { isOpen: boolean }) {
  const onChangeLanguage = (languageId: string) => {
    changeLanguage(languageId)
    closeCurrentModal()
  }

  return (
    <BottomDrawer onClose={closeCurrentModal} isOpen={isOpen}>
      <Typography margin="10px 15px" variant="subtitle1" color="primary.main">
        {t('settings.sections.language.choiceLanguage')}
      </Typography>

      <List component="nav" sx={{ width: '100%' }}>
        {languageInfo.map(language => {
          return (
            <Fragment key={language.languageId}>
              <StyledListItemButton
                key={language.languageId}
                disabled={language.disabled}
                onClick={() => onChangeLanguage(language.languageId)}
              >
                <Box>
                  <Typography component="p" variant="subtitle3">
                    {t(language.name)}
                  </Typography>
                  <Typography component="p" variant="caption1">
                    {language.label}
                  </Typography>
                </Box>

                {i18next.language === language.languageId && <ConfirmIcon />}
              </StyledListItemButton>
              <IntendedDivider variant="inset" />
            </Fragment>
          )
        })}
      </List>
    </BottomDrawer>
  )
}
